module.exports = __webpack_public_path__ + "static/logo-ai2-white-withText-micro-0d210bc8b21f9793c993cba873c2b453.svg";